import { render, staticRenderFns } from "./TableColumnSelectorMenu.vue?vue&type=template&id=97f1aee6&scoped=true"
import script from "./TableColumnSelectorMenu.vue?vue&type=script&lang=js"
export * from "./TableColumnSelectorMenu.vue?vue&type=script&lang=js"
import style0 from "./TableColumnSelectorMenu.vue?vue&type=style&index=0&id=97f1aee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f1aee6",
  null
  
)

export default component.exports